<template>
    <MainCard>
        <div class=" w-full   animate-fade-in">

            <div class=" ">
                <label for="phone" class="block mb-1 text-base font-medium ">{{ $t('phone.label') }}</label>
                <p class="text-sm text-gray-600 font-normal  mb-2 ">
                    {{ $t('phone.description') }}
                </p>
                <input v-model="phone" @input="handlePhoneInput" :class="[
                    'w-full rounded-lg border-2 border-slate-300 focus:border-slate-400 bg-slate-50 text-sm placeholder-gray-500 outline-none transition duration-300 px-3 py-3   mx-auto cursor-pointer mb-3  ',
                    locale === 'ar' ? ' font-arabic' : ''
                ]" type="text" placeholder="Ex: 0770770000" maxlength="10" />

                <p v-if="phoneError" class="text-sm text-red-500 mb-5" :class="{ ' font-arabic': locale === 'ar' }">
                    {{ $t("phone.error." + phoneMessage) }}
                </p>
            </div>


            <div class="w-full  ">
                <div @click="submitPhone" :class="[
                    'text-sm w-fit rounded-lg font-bold px-5 py-2 text-center mx-auto transition duration-200 hover:cursor-pointer mb-3 ',
                    locale === 'ar' ? ' font-arabic' : '',
                    isValidPhone
                        ? 'bg-gradient-to-br from-cocacola-primary to-[#b1060c] text-white hover:bg-[#a32b45]'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                ]">
                    {{ $t('phone.participate') }}
                </div>
            </div>
        </div>

    </MainCard>
</template>

<script setup>

import { computed, onMounted, ref, defineEmits } from 'vue';
import { useParticipationStore } from '@/stores/useParticipationStore';
import { useRouter } from 'vue-router';
import MainCard from '@/components/mainCard.vue';

const emit = defineEmits(['toggleLoading']);

const participationStore = useParticipationStore();
const router = useRouter()
const phone = ref('');
const phoneError = ref(false);
const phoneMessage = ref('');

const handlePhoneInput = (e) => {
    phone.value = e.target.value.replace(/\D/g, '')
}

const isValidPhone = computed(() => /^0[567]\d{8}$/.test(phone.value));


const submitPhone = async () => {


    if (!isValidPhone.value) {
        phoneError.value = true
        phoneMessage.value = "invalid"
        return;
    }

    phoneError.value = false

    emit('toggleLoading', true);

    try {
        let response = await participationStore.submitPhone(phone.value);

        if (response.success) {
            console.log('response.success :>> ', response.success);
            setTimeout(() => {
                emit('toggleLoading', false);
                return router.push({ name: 'photo', params: { code: participationStore.link } });

            }, 2000);


        } else {


            phoneError.value = true
            phoneMessage.value = response.message
            return;
        }


    } catch (error) {
        console.log('hehe :>> ');
        phoneError.value = true
        phoneMessage.value = "invalid"
    }

}


onMounted(async () => {
    participationStore.resetStore();
})
</script>

<style>
@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    animation: fade-in 0.8s ease-out forwards;
}
</style>